import {useState} from 'react';
import type {Connection} from '../../lib/types';

export {platformName} from '../../lib/publishingIdentity';

export function SenderAvatar({connection}:{connection?:Connection}){
 const [failedUrl,setFailedUrl]=useState<string>();
 const url=connection?.avatarUrl;
 return <span className="sender-avatar" aria-hidden="true">
  {url&&url!==failedUrl&&/^https:\/\//i.test(url)
   ?<img src={url} alt="" referrerPolicy="no-referrer" onError={()=>setFailedUrl(url)}/>
   :(connection?.displayName||'P').slice(0,1)}
 </span>;
}
